import { computed, shallowRef } from "vue";

import type {
    UpdateApplicationsListPublicTableFiltersEvent,
} from "@/components/district-applications-list/types";
import type { DistrictApplicationsPublicTableFilters } from "@/composables/district-applications-list/types";

/**
 * Composable used for managing public district apps table filters state
 */
export function useTableFilters() {
    const appOrDomainName = shallowRef<string>();

    const filters = computed<DistrictApplicationsPublicTableFilters>(() => {
        return {
            AppOrDomainName: appOrDomainName.value,
        };
    });

    /**
     * Updates the public district apps table filters based on the new filters provided.
     */
    function onTableFiltersUpdate(newFilters: UpdateApplicationsListPublicTableFiltersEvent) {
        appOrDomainName.value = newFilters.appOrDomainName;
    }

    return { filters, onTableFiltersUpdate };
}